import {
    Directive,
    ElementRef,
    Input,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import {
    FormControl
} from '@angular/forms';

@Directive({
    selector: '[uppercase][formControl]'
})
export class UppercaseFormControlDirective implements OnChanges {
    @Input() formControl: FormControl;
    value: any;

    constructor(private _elementRef: ElementRef) {
    }

    // Update styling to show upper cased input value
    updateInputStyle() {
        const [input] = this._elementRef.nativeElement.tagName === 'INPUT' ?
            [this._elementRef.nativeElement] :
            this._elementRef.nativeElement.getElementsByTagName('input');
        if (!input) return;
        input.style['text-transform'] = this.value ? 'uppercase' : '';
    }

    // Make sure form control value as upper cased
    updateValue(value) {
        this.value = value && value.toUpperCase();
        this.updateInputStyle();

        if (this.value === value) return;

        this.formControl.setValue(this.value, {
            emitModelToViewChange: false,
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.formControl) return;

        this.updateValue(this.formControl.value);

        this.formControl.valueChanges.subscribe((value) => {
            this.updateValue(value);
        });
    }
}
